export default __webpack_public_path__ + "static/airbnb-7-05d1ffc2468a1ebb8f5474bc0b45e6ee.png";